module.exports = function(bootstrap) {
    bootstrap.run(["Service", function (Service) {
        return new Service({
            name: 'claimSummarySupplement',
            group: "rbsmbl",
            url: "/rbsmbl/x-services/asp/claims/summary",
            fetch: function(agreementId, startDate, endDate){
                return this.get({
                    agreementId : agreementId,
                    fromDate: startDate.substr(4,2)+'/'+startDate.substr(6,2)+'/'+startDate.substr(0,4),
                    toDate: endDate.substr(4,2)+'/'+endDate.substr(6,2)+'/'+endDate.substr(0,4)
                });
            }
        });
    }]);
};
